import { Check } from 'lucide-react'
import type { ComponentProps } from 'react'
import { Checkbox as TamaguiCheckbox } from 'tamagui'

// Tamagui's Checkbox for the behaviour (role, aria-checked, keyboard, a hidden input inside a
// <form> for name/value), with the STYLE.md look: 24 px box, 2 px control border, primary when
// checked (read from the controlled `checked` prop). Not `native`: on web that renders an
// uncontrolled <input> that never calls onCheckedChange.
// The 44 px touch target is the <label htmlFor={id}> next to it - a <button> is labelable.
export function Checkbox({
  invalid,
  checked,
  ...props
}: ComponentProps<typeof TamaguiCheckbox> & { invalid?: boolean }) {
  return (
    <TamaguiCheckbox
      width={24}
      height={24}
      flexShrink={0}
      borderWidth={2}
      borderRadius={6}
      borderColor={
        checked ? 'border-color-focus' : invalid ? 'border-color-danger' : 'border-color-control'
      }
      backgroundColor={checked ? 'primary' : 'surface'}
      cursor="pointer"
      checked={checked}
      outlineStyle="solid"
      outlineColor="outline-color"
      outlineOffset={2}
      outlineWidth="0 focus-visible:2"
      opacity={props.disabled ? 0.6 : 1}
      {...props}
    >
      <TamaguiCheckbox.Indicator>
        <Check
          aria-hidden
          size={16}
          strokeWidth={3}
          color="var(--on-primary)"
        />
      </TamaguiCheckbox.Indicator>
    </TamaguiCheckbox>
  )
}
